module.exports = __webpack_public_path__ + "static/media/email-line.43666513.svg";